import type { AxiosRequestConfig } from 'axios'
import merge from 'lodash.merge'

import type { NoteId, NoteMutator, NoteInitializer } from '@beaded/models'

import * as apiUtils from '.'

const url = '/note'

export const create = (data: NoteInitializer) => apiUtils.POST(`${url}/`, data)

export const get = (id: NoteId, options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/${id}`, merge({}, options))

export const getAll = (options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/`, merge({}, options))

export const update = (id: NoteId, data: NoteMutator) =>
  apiUtils.PUT(`${url}/${id}`, data)

export const remove = (id: NoteId) => apiUtils.DELETE(`${url}/${id}`)
